import Link from "next/link";
import { FaArrowRight } from "react-icons/fa";
import type { ArticleSummary } from "@/data/articles";

export function GuideRelatedCard({ article }: { article: ArticleSummary }) {
  return (
    <Link
      href={`/guides/${article.slug}`}
      className="group flex items-start gap-3 rounded-2xl border border-zinc-200/90 bg-white p-4 shadow-sm transition-all duration-300 hover:border-emerald-200 hover:shadow-[0_12px_32px_-18px_rgba(16,185,129,0.16)]"
    >
      <div className="min-w-0 flex-1">
        <h3 className="line-clamp-2 text-sm font-bold leading-snug text-[#1C1C1C] transition-colors group-hover:text-emerald-900 sm:text-[0.9375rem]">
          {article.title}
        </h3>
      </div>
      <span className="mt-1 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-zinc-200 bg-zinc-50 text-zinc-400 transition group-hover:border-emerald-200 group-hover:bg-emerald-50 group-hover:text-emerald-700">
        <FaArrowRight className="text-[9px] -rotate-45" aria-hidden="true" />
      </span>
    </Link>
  );
}
